// extracted by mini-css-extract-plugin
export var arrow = "Paragraph-module--arrow--ac84c";
export var arrowNo = "Paragraph-module--arrow_no--7755d";
export var arrowYes = "Paragraph-module--arrow_yes--ca1d7";
export var big = "Paragraph-module--big--50312";
export var flex = "Paragraph-module--flex--94ac1";
export var flex1 = "Paragraph-module--flex_1--ac4e4";
export var flexCenter = "Paragraph-module--flex_center--8bd92";
export var flexCenterCol = "Paragraph-module--flex_center_col--afd60";
export var flexCol = "Paragraph-module--flex_col--88f37";
export var flexFixCenterCol = "Paragraph-module--flex_fix_center_col--316e1";
export var flexFixedCenterCol = "Paragraph-module--flex_fixed_center_col--9efa6";
export var medium = "Paragraph-module--medium--66926";
export var rotating = "Paragraph-module--rotating--e0e10";
export var small = "Paragraph-module--small--10aed";